import { useState } from "react";
import { useAuth } from "../../app/auth/AuthProvider";
import { ApiProblem, formatProblem } from "../../api/problemDetails";
import { useAppNavigate } from "../../app/router/router";

export function LoginPage(): React.JSX.Element {
  const { login } = useAuth();
  const navigate = useAppNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setBusy(true); setError(null);
    try { await login(email, password); navigate("/campaigns", true); }
    catch (reason) { setError(reason instanceof ApiProblem ? formatProblem(reason) : "Sign in could not be completed."); }
    finally { setBusy(false); }
  };
  return <main className="auth-page"><section className="auth-card"><p className="eyebrow">CONTENTFORGE</p><h1>Operator Console</h1><p>Sign in to your active workspace.</p><form onSubmit={event => void submit(event)} noValidate>
    <label>Email<input type="email" autoComplete="username" value={email} onChange={event => setEmail(event.target.value)} required /></label>
    <label>Password<input type="password" autoComplete="current-password" value={password} onChange={event => setPassword(event.target.value)} required /></label>
    {error && <p className="field-error" role="alert">{error}</p>}
    <button className="button-primary" disabled={busy}>{busy ? "Signing in…" : "Sign in"}</button>
  </form></section></main>;
}
